<template>

  <div class="dashboard">

    <app-header />

    <div class="container">
      <div class="d-flex align-items-center justify-content-between my-3">
        <h1>{{ _lang('Projects') }}</h1>
        <router-link class="btn btn-primary" :to="{name:'project-new'}">{{ _lang('New project') }}</router-link>
      </div>

      <div class="listing-filter" v-if="projects.length>10">
      	<div>
	      	<input :placeholder="_lang('Search project')" v-model="search.term" type="text" class="form-control">
	      </div>
	      <div class="d-flex align-items-center ">
	      <div class="listing-view mr-2">
	      	<div @click="changeView('grid')" :class="{active:listingView=='grid'}"><ico size="22" ico="gridview" /></div>
	      	<div @click="changeView('list')" :class="{active:listingView=='list'}"><ico size="22" ico="listview" /></div>
	      </div>
	      <div class="listing-order">
	      	<select v-model="listingOrder" @change="changeOrder" class="form-control">
	      		<option value="-updated_at">Data de alteração ▼</option>
	      		<option value="-created_at">Data de criação ▼</option>
	      		<option value="name">Nome ▲</option>
	      	</select>
	      </div>
	      </div>
      </div>


      <div class="card-listing projects" v-if="listingView=='grid'">
        <div class="item" v-for="project in results" :key="project.id">
          <div class="card">
            <figure>
              <img class="card-img-top" loading="lazy" :src="thumbnail_url(project)" alt="">
            </figure>
            <div class="card-header">
                <h5 class="text-truncate">{{ project.name }}</h5>
                <a class="is-desktop" :href="'https://'+url(project.slug)" target="_blank">
                  <svg class="icosvg" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" />
                  </svg>
                </a>
            </div>
            <div class="card-body">
              <p class="text-truncate">{{ project.domain || _lang('(domain not set)') }}</p>
              <div class="card-actions">
                <router-link :to="'/project/'+project.id" class="btn btn-block btn-primary">{{ _lang('Manage') }}</router-link>
                <div class="dropdown ml-1">
                  <span class="btn btn-light" @click="openDropdown(project.slug)">&hellip;</span>
                  <div class="dropdown-content" v-if="isOpenDropdown(project.slug)" v-on-clickaway="closeDropdown">
                    <a class="btn btn-warning" @click="duplicate(project.id)" href="#">{{ _lang('Duplicate') }}</a>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="card-footer"></div> -->
          </div>
        </div>
      </div>

      <div class="list-listing projects" v-if="listingView=='list'">

      	<div class="item" v-for="project in results" :key="project.id">
          <h6 class="text-truncate mb-0 flex-grow-1">{{ project.name }}</h6>
          <small class="text-truncate" v-if="project.domain">{{ project.domain }}</small>
          <div class="card-actions">
          	<a class="is-desktop" :href="'https://'+url(project.slug)" target="_blank"><ico ico="target" /></a>
          	<router-link :to="'/project/'+project.id" class="btn btn-sm btn-primary">{{ _lang('Manage') }}</router-link>
          	<div class="is-desktop dropdown ml-1">
          		<span class="btn btn-light btn-sm" @click="openDropdown(project.slug)">&hellip;</span>
          		<div class="dropdown-content" v-if="isOpenDropdown(project.slug)" v-on-clickaway="closeDropdown">
          			<a class="btn btn-warning btn-sm" @click="duplicate(project.id)" href="#">{{ _lang('Duplicate') }}</a>
          		</div>
          	</div>
          </div>
        </div>

      </div>

    </div>


  </div>

</template>


<style scoped>

.dropdown {
  position:relative;
}
.dropdown .dropdown-content{
  position:absolute;
  right:0;
  top:100%;
  background:#f8f9fa;
  box-shadow: 1px 1px 3px rgba(0,0,0,.5);
  padding:10px;
  z-index: 2;
}
</style>


<script>
import axios from 'axios';

import { mixin as clickaway } from 'vue-clickaway';

import appHeader from '../components/appHeader'
import Ico from '../components/Ico'

export default {
  name: 'dashboard',
  mixins: [ clickaway ],
  components:{
    appHeader,
    Ico,
  },
  data() {
    return {
    	search:{
    		term:'',
    	},
    	listingOrder:'-updated_at',
    	listingView:'grid',
      projects:[],
      dropdownActive:'',
    }
  },
  computed:{
  	results(){
  		var dir = this.listingOrder[0]=='-'?-1:1;
  		var field = this.listingOrder.replace(/^-/,'');

  		if(!this.search.term) {
  			return this.projects.sort((a,b)=>{
					if(a[field]==b[field]) return 0;
					return (a[field]<b[field]?-1:1) * dir;
  			})
  		}

  		var term = this.search.term.trim().toLowerCase();
  		return this.projects.filter(project=>{
  			return project.name.toLowerCase().includes(term);
  		}).sort((a,b)=>{
				if(a[field]==b[field]) return 0;
				return (a[field]<b[field]?-1:1) * dir;
			})
  	}
  },
  methods:{

  	thumbnail_url(project){
		if(!project.thumbnail_timestamp) return '/placeholder.jpg';
  		return '/thumbnails/'+project.uuid+'.jpg?ts='+project.thumbnail_timestamp;
  	},
  	changeOrder(){
  		localStorage.setItem('listingOrder',this.listingOrder);
  	},
  	changeView(newval){
  		this.listingView = newval;
  		localStorage.setItem('listingView',newval);
  	},

    openDropdown(dropdown_id){
      console.log('dropdown_id',dropdown_id);
      this.dropdownActive = dropdown_id;
    },
    isOpenDropdown(dropdown_id){
      return this.dropdownActive == dropdown_id;
    },
    closeDropdown(){
      this.dropdownActive = '';
    },

    duplicate(project_id){
      axios({
        method: 'post',
        url: `/api/projects/${project_id}/duplicate`,
      }).then((res)=>{
        this.closeDropdown();
        this.getProjects();
      });
    },

    url(slug){
      return slug+'.'+process.env.VUE_APP_BASEURL;
    },
    dataBr(data){
      var d = new Date(data);
      return ('0'+d.getDate()).substr(-2) + '/' +('0'+(d.getMonth()+1)).substr(-2)+'/'+d.getFullYear();
    },
    getProjects(){
      this.$store.dispatch('startLoading');
      axios({
        url: '/api/projects',
      }).then((res) => {
        this.projects = res.data;
      }).finally(()=>{
        this.$store.dispatch('stopLoading');
      });
    },



  },
  mounted(){
		if(localStorage.getItem('listingView')) this.listingView = localStorage.getItem('listingView');
		if(localStorage.getItem('listingOrder')) this.listingOrder = localStorage.getItem('listingOrder');




    this.getProjects();

  }

}



</script>
